module.exports = __webpack_public_path__ + "static/img/shuqitui-logo.8130551.png";


//////////////////
// WEBPACK FOOTER
// ./static/shuqitui-logo.png
// module id = v4BL
// module chunks = 6